<template>
  <div class="container">
    <navigation/>
    <div class="wrapper">
        <form @submit.prevent="uploadFiles">
        <h2>Dodaj zdjęcia do galerii</h2>
        <div class="buttons">
         <label class="inputlabel" for="files">
              <img src="@/assets/upload.svg" class="upload">
              Wybierz zdjęcie
        </label>
        <select @change="selCat" required>
          <option>Wybierz kategorie</option>
          <option v-for="category in categories" :value="category.name" :key="category.id">{{category.name}}</option>
        </select>
        <input name="files" type="file" class="inputfile files" id="files" multiple accept="image/jpeg, image/jpg, image/png" required @change="getFiles">
        <input type="submit" value="Wyślij" class="uploadBtn">
        </div>
        <p class="info">Im wyższa wartość tym zdjęcie będzie wyżej na liście.</p>
        <select class="rangeSelect" @change="selectRange">
          <option>Wybierz wartość od 1 do 5</option>
          <option value="1">1</option>
          <option value="2">2</option>
          <option value="3">3</option>
          <option value="4">4</option>
          <option value="5">5</option>
        </select>
      </form>
      <div v-show="galleryUploadList.length > 0" class="counter">Wybrano {{galleryUploadList.length}} plików.</div>
      <progress :value="doneFiles" :max="totalFiles"></progress>
      <p v-if="compress">Gdy zdjęcia się skompresują naciśnij "wyślij".</p>
      <p v-if="upload">Wysyłanie zdjęć</p>
    </div>
    <div class="delWrapper">
      <h3>Usuń zdjęcia</h3>
      <select @change="choseCategory">
          <option>Wybierz kategorie</option>
          <option v-for="category in categories" :value="category.name" :key="category.id">{{category.name}}</option>
      </select>
          <div class="grid">
            <div class="image" v-for="image in images" :key="image.id" :style="`background-image: url('${image.url}')`"><input type="checkbox"></div>
          </div>
    </div>
    <div class="center">
      <router-link tag="button" class="backBtn" to="/admin">Wróć na główną strone</router-link>
    </div>
    <Footer :class="{binded: images.length > 30}" />
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import Footer from '@/components/Footer.vue';
import navigation from '@/components/adminNav.vue';
export default {
  components:{
    Footer, navigation
  },
  computed:{
    ...mapState({
      galleryUploadList: state=>state.compress.galleryUploadList,
      categories: state=>state.compress.categories,
      selectedCategory: state=>state.compress.selectedCategory,
      totalFiles: state=>state.compress.totalFiles,
      doneFiles: state=>state.compress.doneFiles,
      compress: state=>state.compress.compress,
      upload: state=>state.compress.uploading,
      images: state=>state.compress.bindedItems,
      range: state=>state.compress.range,
      message: state=>state.compress.message
    })
  },
  methods:{
    // ...mapMutations(['selectedImages', 'uploadFiles'])
    ...mapMutations(['getFiles', 'uploadFiles', 'bindGalleryCategories', 'selCat', 'bindGalleryItems', 'selectRange']),
    choseCategory(element){
      this.bindGalleryItems(element.target.value)
    }
  },
  mounted(){
    this.bindGalleryCategories();
  }
}
</script>

<style scoped lang="scss">
.rangeSelect{
  margin: 6px 0;
}
.info{
  width: 400px;
  margin: 6px 0;
}
.binded{
  position: relative !important;
}
.delWrapper{
  margin: 0 34px;
}
.grid{
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
}
.image{
  width: 100px;
  height: 100px;
  background-size: cover;
  background-position: center;
  display: flex;
  justify-content: flex-end;
  margin: 3px;
  cursor: pointer;
}
select{
  cursor: pointer;
}
.inputlabel{
  cursor: pointer;
}
.backBtn{
  color: white;
  background: black;
  border: none;
  padding: 12px 24px;
  margin: 24px 0;
  cursor: pointer;
}
.center{
  display: flex;
  justify-content: center;
  align-items: center;
}
.upload{
  width: 14px;
}
.uploadBtn{
  background: black;
  color: white;
  padding: 8px 22px;
  border: none;
  margin-left: 6px;
  cursor: pointer;
}
.buttons{
  display: flex;
  flex-direction: row;
  margin: 22px 0;
}
.inputfile {
	width: 0.1px;
	height: 0.1px;
	opacity: 0;
	overflow: hidden;
	position: absolute;
	z-index: -1;
}
.inputlabel {
    padding: 6px 16px;
    color: white;
    background-color: black;
    display: flex;
    justify-content: space-around;
    align-items: center;
    width: 170px;
}
.wrapper{
  padding: 120px 34px;
}
.footer_container{
  width: 100%;
  position: absolute;
  bottom: 0;
}
</style>